import Cookies from 'universal-cookie';

const SELECTORS = {
  WRAPPER: '.js-cookie-info',
  BTN_APPLY: '.js-cookie-info-btn-apply',
};

module.exports = () => {
  document.addEventListener('click', (event) => {
    const btnApply = event.target.closest(SELECTORS.BTN_APPLY);
    if (!btnApply) {
      return;
    }
    event.preventDefault();
    const wrapper = btnApply.closest(SELECTORS.WRAPPER);

    const cookies = new Cookies();
    const expires = new Date();
    expires.setTime(expires.getTime() + 24 * 60 * 60 * 1000);
    cookies.set(wrapper.dataset.cookieName, 'true', { path: '/', expires });

    wrapper.remove();
  });
};



/** WEBPACK FOOTER **
 ** D:/phpstorm/szar/src/js/modules/cookie-info.js
 **/